import { motion } from "framer-motion";
import { Users, Palette, Music, PenTool, Briefcase } from "lucide-react";

const audiences = [
  {
    icon: <Users size={28} />,
    title: "Multi-Generational Family Getaways",
    description:
      "Sleeps up to 8 across four queen bedrooms, with a fully equipped kitchen for family meals, a large fenced yard for kids, and communal living spaces designed for togetherness.",
  },
  {
    icon: <Palette size={28} />,
    title: "Artist & Creative Retreats",
    description:
      "Abundant natural light, inspiring views of Bruny Island and the D'Entrecasteaux Channel, quiet workspace, and the ever-changing Tasmanian landscape as your muse.",
  },
  {
    icon: <Music size={28} />,
    title: "Musicians' Retreat",
    description:
      "A completely private setting on a working farm with no close neighbours — the perfect space to compose, rehearse, and create without interruption.",
  },
  {
    icon: <PenTool size={28} />,
    title: "Writers' Retreat",
    description:
      "Solitude and cozy interiors free from distraction. Curl up by the heater with a cup of tea, or write on the deck overlooking the channel. Desk space and high-speed WiFi included.",
  },
  {
    icon: <Briefcase size={28} />,
    title: "Executive Recharge",
    description:
      "Disconnect and recharge with an infrared sauna, outdoor bathtub, complete privacy, and high-speed WiFi for when you need to stay connected. Just 60 minutes from Hobart Airport.",
  },
];

const AudienceSection = () => {
  return (
    <section className="py-16 md:py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.span
            className="inline-block text-cottage-600 font-medium text-sm px-3 py-1 bg-cottage-50 rounded-full mb-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Perfect For
          </motion.span>
          <motion.h2
            className="text-3xl md:text-4xl font-bold text-cottage-800 mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            Your Ideal Tasmanian Retreat
          </motion.h2>
          <motion.p
            className="text-cottage-600"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            Whether you're travelling from Melbourne, Sydney, Brisbane, Perth, or beyond — The Cottage at Flowerpot
            is the perfect Southern Tasmania accommodation for families, creatives, and professionals alike.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {audiences.map((audience, index) => (
            <motion.div
              key={audience.title}
              className="bg-white/80 backdrop-blur-sm border border-cottage-100 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow duration-300"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="text-cottage-600 mb-4">{audience.icon}</div>
              <h3 className="text-xl font-semibold text-cottage-800 mb-3">
                {audience.title}
              </h3>
              <p className="text-cottage-600 text-sm leading-relaxed">
                {audience.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AudienceSection;
